import React, { useEffect, useRef } from "react";

/**
 * Hook for keeping track of a variable's previous value
 * 
 * Useful in scenarios where we need a variable previous value for
 * some comparison to its current value
 * 
 * @param  value - a variable to track 
 * @returns 
 */
const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export default usePrevious;